import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    modeClassic: 'Classic',
    modeCrazy: 'Crazy',
    modeSharing: 'Split',
    modeLastCase: 'Last case',
    modeClassicRule: 'The biggest total takes every drop',
    modeCrazyRule: 'The smallest total takes every drop',
    modeSharingRule: 'Nobody loses: all drops are split between players',
    modeLastCaseRule: 'Only the last case counts: the best drop in it takes everything',
    format2: '1 vs 1',
    format3: '3 players',
    format4: '4 players',
    formatTeam: '2 vs 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Private',
    bandFinal: 'Headliners',
    viewers: 'Watching',
    bank: 'Total drops',
    entry: 'Entry',
    statusWaiting: 'Waiting',
    statusRunning: 'Live',
    statusCompleted: 'Finished',
    statusCancelled: 'Cancelled',
    settingsTitle: 'Battle settings',
    settingsReactions: 'Reactions',
    settingsReactionsHint: 'Emoji from players and viewers',
    settingsAffordable: 'Only within my balance',
    settingsAffordableHint: 'Hide battles you cannot afford to enter',
    settingsHideRunning: 'Hide battles in progress',
    settingsHideRunningHint: 'Show only battles you can still join',
    emptyFiltered: 'Nothing matches your settings',
    emptyFilteredHint: 'Turn off a filter in the settings to see more battles',
    reasonNotWaiting: 'The battle has already started',
    reasonFull: 'No free seats',
    reasonAlreadyIn: 'You are in',
    reasonInsufficientBalance: 'Not enough balance',
    reasonTradeLinkRequired: 'Add your trade link first',
    reasonMaxActiveBattles: 'You already have {{limit}} active battles',
    reasonWithdrawalsBlocked: 'Battles are unavailable for your account',
    reasonMultiacc: 'A linked account is already in this battle',
    reasonNotParticipant: 'Only players can do this',
    reasonNotCompleted: 'Wait for the battle to finish',
    reasonNothingToSell: 'Nothing to sell',
    reasonRematchExpired: 'The rematch invite has expired',
    reasonRematchExists: 'A rematch is already set up',
    reasonNoOpponents: 'No one to play with yet',
  },
  ru: {
    modeClassic: 'Классика',
    modeCrazy: 'Crazy',
    modeSharing: 'Поровну',
    modeLastCase: 'Последний кейс',
    modeClassicRule: 'Кто выбил больше — забирает все дропы',
    modeCrazyRule: 'Кто выбил меньше — забирает все дропы',
    modeSharingRule: 'Никто не в минусе: все дропы делятся между игроками',
    modeLastCaseRule: 'Считается только последний кейс: лучший дроп из него забирает всё',
    format2: '1 на 1',
    format3: '3 игрока',
    format4: '4 игрока',
    formatTeam: '2 на 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Приватный',
    bandFinal: 'Хедлайнеры',
    viewers: 'Смотрят',
    bank: 'Всего выбито',
    entry: 'Вход',
    statusWaiting: 'Ожидание',
    statusRunning: 'Идёт',
    statusCompleted: 'Завершён',
    statusCancelled: 'Отменён',
    settingsTitle: 'Настройки баттлов',
    settingsReactions: 'Реакции',
    settingsReactionsHint: 'Эмодзи игроков и зрителей',
    settingsAffordable: 'Только по балансу',
    settingsAffordableHint: 'Скрывать баттлы, на вход в которые не хватает',
    settingsHideRunning: 'Скрывать идущие',
    settingsHideRunningHint: 'Показывать только баттлы, куда ещё можно войти',
    emptyFiltered: 'Под настройки ничего не подходит',
    emptyFilteredHint: 'Выключи фильтр в настройках, чтобы увидеть больше баттлов',
    reasonNotWaiting: 'Баттл уже стартовал',
    reasonFull: 'Свободных мест нет',
    reasonAlreadyIn: 'Ты в игре',
    reasonInsufficientBalance: 'Не хватает баланса',
    reasonTradeLinkRequired: 'Сначала добавь трейд-ссылку',
    reasonMaxActiveBattles: 'У тебя уже {{limit}} активных баттла',
    reasonWithdrawalsBlocked: 'Баттлы недоступны для твоего аккаунта',
    reasonMultiacc: 'В этом баттле уже есть связанный аккаунт',
    reasonNotParticipant: 'Это могут только игроки',
    reasonNotCompleted: 'Дождись конца баттла',
    reasonNothingToSell: 'Продавать нечего',
    reasonRematchExpired: 'Приглашение на реванш истекло',
    reasonRematchExists: 'Реванш уже создан',
    reasonNoOpponents: 'Пока не с кем играть',
  },
  uz: {
    modeClassic: 'Klassik',
    modeCrazy: 'Crazy',
    modeSharing: 'Teng',
    modeLastCase: 'Oxirgi keys',
    modeClassicRule: 'Kim koʻproq chiqargan boʻlsa — barcha droplarni oladi',
    modeCrazyRule: 'Kim kamroq chiqargan boʻlsa — barcha droplarni oladi',
    modeSharingRule: 'Hech kim yutqazmaydi: barcha droplar oʻyinchilar orasida boʻlinadi',
    modeLastCaseRule: 'Faqat oxirgi keys hisobga olinadi: undagi eng yaxshi drop hammasini oladi',
    format2: '1 ga 1',
    format3: '3 oʻyinchi',
    format4: '4 oʻyinchi',
    formatTeam: '2 ga 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Shaxsiy',
    bandFinal: 'Xedlaynerlar',
    viewers: 'Tomosha qilmoqda',
    bank: 'Jami chiqdi',
    entry: 'Kirish',
    statusWaiting: 'Kutilmoqda',
    statusRunning: 'Jonli',
    statusCompleted: 'Tugadi',
    statusCancelled: 'Bekor qilindi',
    settingsTitle: 'Jang sozlamalari',
    settingsReactions: 'Reaksiyalar',
    settingsReactionsHint: 'Oʻyinchi va tomoshabinlar emojisi',
    settingsAffordable: 'Faqat balansga yarasha',
    settingsAffordableHint: 'Kirishga pul yetmaydigan janglarni yashirish',
    settingsHideRunning: 'Boshlanganlarni yashirish',
    settingsHideRunningHint: 'Faqat hali kirish mumkin boʻlgan janglar',
    emptyFiltered: 'Sozlamalarga mos jang yoʻq',
    emptyFilteredHint: 'Koʻproq jang koʻrish uchun sozlamalarda filtrni oʻchir',
    reasonNotWaiting: 'Battle allaqachon boshlangan',
    reasonFull: 'Boʻsh joy yoʻq',
    reasonAlreadyIn: 'Sen oʻyindasan',
    reasonInsufficientBalance: 'Balans yetarli emas',
    reasonTradeLinkRequired: 'Avval trade-havolani qoʻsh',
    reasonMaxActiveBattles: 'Senda allaqachon {{limit}} ta faol battle bor',
    reasonWithdrawalsBlocked: 'Battlelar sening akkauntingga ochiq emas',
    reasonMultiacc: 'Bu battleda bogʻlangan akkaunt allaqachon bor',
    reasonNotParticipant: 'Buni faqat oʻyinchilar qila oladi',
    reasonNotCompleted: 'Battle tugashini kut',
    reasonNothingToSell: 'Sotadigan narsa yoʻq',
    reasonRematchExpired: 'Revansh taklifi muddati oʻtdi',
    reasonRematchExists: 'Revansh allaqachon yaratilgan',
    reasonNoOpponents: 'Hozircha oʻynaydigan odam yoʻq',
  },
  fa: {
    modeClassic: 'کلاسیک',
    modeCrazy: 'Crazy',
    modeSharing: 'مساوی',
    modeLastCase: 'کیس آخر',
    modeClassicRule: 'هر کس بیشتر درآورد همه دراپ‌ها را می‌برد',
    modeCrazyRule: 'هر کس کمتر درآورد همه دراپ‌ها را می‌برد',
    modeSharingRule: 'هیچ‌کس ضرر نمی‌کند: همه دراپ‌ها بین بازیکن‌ها تقسیم می‌شود',
    modeLastCaseRule: 'فقط کیس آخر حساب می‌شود: بهترین دراپ آن همه چیز را می‌برد',
    format2: '1 به 1',
    format3: '3 بازیکن',
    format4: '4 بازیکن',
    formatTeam: '2 به 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'خصوصی',
    bandFinal: 'هدلاینرها',
    viewers: 'در حال تماشا',
    bank: 'مجموع دراپ‌ها',
    entry: 'ورود',
    statusWaiting: 'در انتظار',
    statusRunning: 'زنده',
    statusCompleted: 'تمام‌شده',
    statusCancelled: 'لغو شد',
    settingsTitle: 'تنظیمات نبرد',
    settingsReactions: 'واکنش‌ها',
    settingsReactionsHint: 'ایموجی بازیکنان و تماشاگران',
    settingsAffordable: 'فقط در حد موجودی',
    settingsAffordableHint: 'نبردهایی که پول ورودشان را نداری پنهان شوند',
    settingsHideRunning: 'پنهان کردن نبردهای در جریان',
    settingsHideRunningHint: 'فقط نبردهایی که هنوز می‌توان وارد شد',
    emptyFiltered: 'هیچ نبردی با تنظیمات مطابقت ندارد',
    emptyFilteredHint: 'برای دیدن نبردهای بیشتر، فیلتر را در تنظیمات خاموش کن',
    reasonNotWaiting: 'بتل از قبل شروع شده',
    reasonFull: 'جای خالی نیست',
    reasonAlreadyIn: 'تو در بازی هستی',
    reasonInsufficientBalance: 'موجودی کافی نیست',
    reasonTradeLinkRequired: 'اول لینک ترید را اضافه کن',
    reasonMaxActiveBattles: 'تو از قبل {{limit}} بتل فعال داری',
    reasonWithdrawalsBlocked: 'بتل برای حساب تو در دسترس نیست',
    reasonMultiacc: 'یک حساب مرتبط از قبل در این بتل است',
    reasonNotParticipant: 'فقط بازیکن‌ها می‌توانند',
    reasonNotCompleted: 'صبر کن بتل تمام شود',
    reasonNothingToSell: 'چیزی برای فروش نیست',
    reasonRematchExpired: 'دعوت بازی مجدد منقضی شد',
    reasonRematchExists: 'بازی مجدد از قبل ساخته شده',
    reasonNoOpponents: 'هنوز کسی برای بازی نیست',
  },
  pt: {
    modeClassic: 'Clássico',
    modeCrazy: 'Crazy',
    modeSharing: 'Dividido',
    modeLastCase: 'Última caixa',
    modeClassicRule: 'Quem tirar mais leva todos os drops',
    modeCrazyRule: 'Quem tirar menos leva todos os drops',
    modeSharingRule: 'Ninguém sai no prejuízo: todos os drops são divididos entre os jogadores',
    modeLastCaseRule: 'Só a última caixa conta: o melhor drop dela leva tudo',
    format2: '1 x 1',
    format3: '3 jogadores',
    format4: '4 jogadores',
    formatTeam: '2 x 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Privada',
    bandFinal: 'Headliners',
    viewers: 'Assistindo',
    bank: 'Total de drops',
    entry: 'Entrada',
    statusWaiting: 'Aguardando',
    statusRunning: 'Ao vivo',
    statusCompleted: 'Concluída',
    statusCancelled: 'Cancelada',
    settingsTitle: 'Configurações das batalhas',
    settingsReactions: 'Reações',
    settingsReactionsHint: 'Emojis de jogadores e espectadores',
    settingsAffordable: 'Só dentro do meu saldo',
    settingsAffordableHint: 'Esconder batalhas cuja entrada você não pode pagar',
    settingsHideRunning: 'Esconder batalhas em andamento',
    settingsHideRunningHint: 'Mostrar só batalhas em que ainda dá para entrar',
    emptyFiltered: 'Nada corresponde às suas configurações',
    emptyFilteredHint: 'Desative um filtro nas configurações para ver mais batalhas',
    reasonNotWaiting: 'A batalha já começou',
    reasonFull: 'Não há vagas',
    reasonAlreadyIn: 'Você está dentro',
    reasonInsufficientBalance: 'Saldo insuficiente',
    reasonTradeLinkRequired: 'Adicione seu link de troca primeiro',
    reasonMaxActiveBattles: 'Você já tem {{limit}} batalhas ativas',
    reasonWithdrawalsBlocked: 'As batalhas não estão disponíveis para sua conta',
    reasonMultiacc: 'Já existe uma conta vinculada nesta batalha',
    reasonNotParticipant: 'Só os jogadores podem fazer isso',
    reasonNotCompleted: 'Espere a batalha terminar',
    reasonNothingToSell: 'Nada para vender',
    reasonRematchExpired: 'O convite de revanche expirou',
    reasonRematchExists: 'A revanche já foi criada',
    reasonNoOpponents: 'Ainda não há ninguém para jogar',
  },
  tr: {
    modeClassic: 'Klasik',
    modeCrazy: 'Crazy',
    modeSharing: 'Paylaşımlı',
    modeLastCase: 'Son kasa',
    modeClassicRule: 'En çok çıkaran tüm dropları alır',
    modeCrazyRule: 'En az çıkaran tüm dropları alır',
    modeSharingRule: 'Kimse kaybetmez: tüm droplar oyuncular arasında paylaşılır',
    modeLastCaseRule: 'Sadece son kasa sayılır: ondan çıkan en iyi drop her şeyi alır',
    format2: '1v1',
    format3: '3 oyuncu',
    format4: '4 oyuncu',
    formatTeam: '2v2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Özel',
    bandFinal: 'Headliner’lar',
    viewers: 'İzliyor',
    bank: 'Toplam drop',
    entry: 'Giriş',
    statusWaiting: 'Bekliyor',
    statusRunning: 'Canlı',
    statusCompleted: 'Bitti',
    statusCancelled: 'İptal edildi',
    settingsTitle: 'Savaş ayarları',
    settingsReactions: 'Tepkiler',
    settingsReactionsHint: 'Oyuncu ve izleyicilerin emojileri',
    settingsAffordable: 'Sadece bakiyeme uygun',
    settingsAffordableHint: 'Girişine bakiyen yetmeyen savaşları gizle',
    settingsHideRunning: 'Devam edenleri gizle',
    settingsHideRunningHint: 'Sadece hâlâ girilebilen savaşları göster',
    emptyFiltered: 'Ayarlarına uyan savaş yok',
    emptyFilteredHint: 'Daha fazla savaş görmek için ayarlardan bir filtreyi kapat',
    reasonNotWaiting: 'Savaş çoktan başladı',
    reasonFull: 'Boş yer yok',
    reasonAlreadyIn: 'Oyundasın',
    reasonInsufficientBalance: 'Bakiye yetersiz',
    reasonTradeLinkRequired: 'Önce takas linkini ekle',
    reasonMaxActiveBattles: 'Zaten {{limit}} aktif savaşın var',
    reasonWithdrawalsBlocked: 'Savaşlar hesabın için kullanılamıyor',
    reasonMultiacc: 'Bu savaşta zaten bağlantılı bir hesap var',
    reasonNotParticipant: 'Bunu sadece oyuncular yapabilir',
    reasonNotCompleted: 'Savaşın bitmesini bekle',
    reasonNothingToSell: 'Satacak bir şey yok',
    reasonRematchExpired: 'Rövanş daveti süresi doldu',
    reasonRematchExists: 'Rövanş zaten oluşturuldu',
    reasonNoOpponents: 'Henüz oynayacak kimse yok',
  },
  uk: {
    modeClassic: 'Класика',
    modeCrazy: 'Crazy',
    modeSharing: 'Порівну',
    modeLastCase: 'Останній кейс',
    modeClassicRule: 'Хто вибив більше — забирає всі дропи',
    modeCrazyRule: 'Хто вибив менше — забирає всі дропи',
    modeSharingRule: 'Ніхто не в мінусі: усі дропи ділять між гравцями',
    modeLastCaseRule: 'Враховується лише останній кейс: найкращий дроп з нього забирає все',
    format2: '1 на 1',
    format3: '3 гравці',
    format4: '4 гравці',
    formatTeam: '2 на 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Приватний',
    bandFinal: 'Хедлайнери',
    viewers: 'Дивляться',
    bank: 'Усього випало',
    entry: 'Вхід',
    statusWaiting: 'Очікування',
    statusRunning: 'Іде',
    statusCompleted: 'Завершено',
    statusCancelled: 'Скасовано',
    settingsTitle: 'Налаштування батлів',
    settingsReactions: 'Реакції',
    settingsReactionsHint: 'Емодзі гравців і глядачів',
    settingsAffordable: 'Лише за балансом',
    settingsAffordableHint: 'Ховати батли, на вхід у які не вистачає монет',
    settingsHideRunning: 'Ховати ті, що тривають',
    settingsHideRunningHint: 'Показувати лише батли, куди ще можна зайти',
    emptyFiltered: 'Під налаштування нічого не підходить',
    emptyFilteredHint: 'Вимкни фільтр у налаштуваннях, щоб побачити більше батлів',
    reasonNotWaiting: 'Батл уже стартував',
    reasonFull: 'Вільних місць немає',
    reasonAlreadyIn: 'Ти вже в грі',
    reasonInsufficientBalance: 'Не вистачає балансу',
    reasonTradeLinkRequired: 'Спершу додай трейд-посилання',
    reasonMaxActiveBattles: 'У тебе вже {{limit}} активних батлів',
    reasonWithdrawalsBlocked: 'Батли недоступні для твого акаунта',
    reasonMultiacc: 'У цьому батлі вже є пов’язаний акаунт',
    reasonNotParticipant: 'Це можуть робити лише гравці',
    reasonNotCompleted: 'Дочекайся кінця батлу',
    reasonNothingToSell: 'Продавати нічого',
    reasonRematchExpired: 'Запрошення на реванш закінчилося',
    reasonRematchExists: 'Реванш уже створено',
    reasonNoOpponents: 'Поки немає з ким грати',
  },
  de: {
    modeClassic: 'Klassik',
    modeCrazy: 'Crazy',
    modeSharing: 'Geteilt',
    modeLastCase: 'Letzter Case',
    modeClassicRule: 'Wer mehr gedroppt hat, holt sich alle Drops',
    modeCrazyRule: 'Wer weniger gedroppt hat, holt sich alle Drops',
    modeSharingRule: 'Niemand verliert: Alle Drops werden unter den Spielern aufgeteilt',
    modeLastCaseRule: 'Nur der letzte Case zählt: Der beste Drop daraus holt alles',
    format2: '1 gegen 1',
    format3: '3 Spieler',
    format4: '4 Spieler',
    formatTeam: '2 gegen 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Privat',
    bandFinal: 'Headliner',
    viewers: 'Zuschauer',
    bank: 'Drops gesamt',
    entry: 'Eintritt',
    statusWaiting: 'Wartet',
    statusRunning: 'Live',
    statusCompleted: 'Beendet',
    statusCancelled: 'Abgebrochen',
    settingsTitle: 'Battle-Einstellungen',
    settingsReactions: 'Reaktionen',
    settingsReactionsHint: 'Emojis von Spielern und Zuschauern',
    settingsAffordable: 'Nur im Rahmen des Guthabens',
    settingsAffordableHint: 'Battles ausblenden, deren Eintritt du dir nicht leisten kannst',
    settingsHideRunning: 'Laufende ausblenden',
    settingsHideRunningHint: 'Nur Battles zeigen, denen du noch beitreten kannst',
    emptyFiltered: 'Nichts passt zu deinen Einstellungen',
    emptyFilteredHint: 'Schalte in den Einstellungen einen Filter aus, um mehr Battles zu sehen',
    reasonNotWaiting: 'Das Battle hat bereits begonnen',
    reasonFull: 'Keine freien Plätze',
    reasonAlreadyIn: 'Du bist schon dabei',
    reasonInsufficientBalance: 'Nicht genug Guthaben',
    reasonTradeLinkRequired: 'Füge zuerst deinen Trade-Link hinzu',
    reasonMaxActiveBattles: 'Du hast schon {{limit}} aktive Battles',
    reasonWithdrawalsBlocked: 'Battles sind für dein Konto nicht verfügbar',
    reasonMultiacc: 'In diesem Battle ist bereits ein verknüpftes Konto',
    reasonNotParticipant: 'Das können nur Spieler',
    reasonNotCompleted: 'Warte, bis das Battle zu Ende ist',
    reasonNothingToSell: 'Nichts zu verkaufen',
    reasonRematchExpired: 'Die Einladung zur Revanche ist abgelaufen',
    reasonRematchExists: 'Eine Revanche ist schon angelegt',
    reasonNoOpponents: 'Noch niemand zum Spielen da',
  },
  es: {
    modeClassic: 'Clásico',
    modeCrazy: 'Crazy',
    modeSharing: 'A partes iguales',
    modeLastCase: 'Última caja',
    modeClassicRule: 'Quien consiga más se lleva todos los drops',
    modeCrazyRule: 'Quien consiga menos se lleva todos los drops',
    modeSharingRule: 'Nadie pierde: todos los drops se reparten entre los jugadores',
    modeLastCaseRule: 'Solo cuenta la última caja: el mejor drop de ella se lo lleva todo',
    format2: '1 contra 1',
    format3: '3 jugadores',
    format4: '4 jugadores',
    formatTeam: '2 contra 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Privado',
    bandFinal: 'Cabezas de cartel',
    viewers: 'Espectadores',
    bank: 'Total de drops',
    entry: 'Entrada',
    statusWaiting: 'En espera',
    statusRunning: 'En vivo',
    statusCompleted: 'Finalizado',
    statusCancelled: 'Cancelado',
    settingsTitle: 'Ajustes de los battles',
    settingsReactions: 'Reacciones',
    settingsReactionsHint: 'Emojis de jugadores y espectadores',
    settingsAffordable: 'Solo los que pueda pagar',
    settingsAffordableHint: 'Oculta los battles a cuya entrada no llegas',
    settingsHideRunning: 'Ocultar los que están en curso',
    settingsHideRunningHint: 'Muestra solo los battles a los que aún puedes entrar',
    emptyFiltered: 'Nada coincide con tus ajustes',
    emptyFilteredHint: 'Desactiva un filtro en los ajustes para ver más battles',
    reasonNotWaiting: 'El battle ya ha empezado',
    reasonFull: 'No quedan plazas libres',
    reasonAlreadyIn: 'Ya estás dentro',
    reasonInsufficientBalance: 'Saldo insuficiente',
    reasonTradeLinkRequired: 'Primero añade tu enlace de intercambio',
    reasonMaxActiveBattles: 'Ya tienes {{limit}} battles activos',
    reasonWithdrawalsBlocked: 'Los battles no están disponibles para tu cuenta',
    reasonMultiacc: 'En este battle ya hay una cuenta vinculada',
    reasonNotParticipant: 'Solo pueden hacerlo los jugadores',
    reasonNotCompleted: 'Espera a que termine el battle',
    reasonNothingToSell: 'No hay nada que vender',
    reasonRematchExpired: 'La invitación a la revancha ha caducado',
    reasonRematchExists: 'Ya hay una revancha preparada',
    reasonNoOpponents: 'Todavía no hay con quién jugar',
  },
  pl: {
    modeClassic: 'Klasyczny',
    modeCrazy: 'Crazy',
    modeSharing: 'Po równo',
    modeLastCase: 'Ostatnia skrzynka',
    modeClassicRule: 'Kto wybił więcej, zabiera wszystkie dropy',
    modeCrazyRule: 'Kto wybił mniej, zabiera wszystkie dropy',
    modeSharingRule: 'Nikt nie traci: wszystkie dropy są dzielone między graczy',
    modeLastCaseRule: 'Liczy się tylko ostatnia skrzynka: najlepszy drop z niej zabiera wszystko',
    format2: '1 na 1',
    format3: '3 graczy',
    format4: '4 graczy',
    formatTeam: '2 na 2',
    sideA: 'CT',
    sideB: 'T',
    privateTable: 'Prywatny',
    bandFinal: 'Headlinerzy',
    viewers: 'Oglądają',
    bank: 'Łącznie wypadło',
    entry: 'Wejście',
    statusWaiting: 'Oczekiwanie',
    statusRunning: 'Trwa',
    statusCompleted: 'Zakończony',
    statusCancelled: 'Anulowany',
    settingsTitle: 'Ustawienia battle',
    settingsReactions: 'Reakcje',
    settingsReactionsHint: 'Emoji graczy i widzów',
    settingsAffordable: 'Tylko na moje saldo',
    settingsAffordableHint: 'Ukrywaj battle, na których wejście cię nie stać',
    settingsHideRunning: 'Ukryj trwające',
    settingsHideRunningHint: 'Pokazuj tylko battle, do których jeszcze można dołączyć',
    emptyFiltered: 'Nic nie pasuje do twoich ustawień',
    emptyFilteredHint: 'Wyłącz filtr w ustawieniach, aby zobaczyć więcej battle',
    reasonNotWaiting: 'Battle już wystartował',
    reasonFull: 'Brak wolnych miejsc',
    reasonAlreadyIn: 'Już w nim jesteś',
    reasonInsufficientBalance: 'Za mało salda',
    reasonTradeLinkRequired: 'Najpierw dodaj link do wymiany',
    reasonMaxActiveBattles: 'Masz już {{limit}} aktywnych battle',
    reasonWithdrawalsBlocked: 'Battle są niedostępne dla twojego konta',
    reasonMultiacc: 'W tym battle jest już powiązane konto',
    reasonNotParticipant: 'Mogą to robić tylko gracze',
    reasonNotCompleted: 'Poczekaj na koniec battle',
    reasonNothingToSell: 'Nie ma czego sprzedawać',
    reasonRematchExpired: 'Zaproszenie na rewanż wygasło',
    reasonRematchExists: 'Rewanż został już utworzony',
    reasonNoOpponents: 'Na razie nie ma z kim grać',
  },
});
